<app-page-meta pageTitle="finzy - India's premier peer to peer lending solution"
               tags="finzy, peer to peer lending, investment online, manage investments easily, low risk investments, safe investments, alternate investments, high returns, optimise risks, easy investments, p2p lending, investments in India, private money lenders, lending money, online lenders, p2p lender, online lending india, investment opportunities, alternative investments, peer to peer lending india"
               description="finzy is the premier peer to peer lending solution in India. Earn monthly returns by investing in risk optimised loans. We focus on the right borrowers, diversify your investment across multiple loans, help you track your returns and support in collection and recovery to help you earn regular monthly returns.">
</app-page-meta>

<app-header></app-header>
<div class="row mainrow">
  <div class="col-sm-4 leftdiv">
    <div class="rightarrow"></div>
    <div class="leftinnerdiv">
      <p class="lefttxt">Hello there!</p>
      <p class="lefttxt2">Welcome to finzy</p>
    </div>
    <div class="leftarrow"></div>
  </div>
  <div class="col-sm-8 rightdiv">
    <div class="rightinnerdiv">
      <p class="introtxt">Here are a few things you will need to get started:</p>
      <ul class="ulclass">
        <li class="liclass">Your phone for the OTP</li>
        <li class="liclass">PAN Card</li>
        <li class="liclass">Recent passport sized photograph</li>
        <!-- <li class="liclass">IT Returns for the last year</li>
                <li class="liclass">Bank statements for the last 6 months</li> -->
        <li class="liclass">Aadhaar card or any proof of permanent address</li>
    </ul>

      <app-referral-partner-code [isDisabled]="isUserRegistered" *ngIf="referralFeatureEnabled"></app-referral-partner-code>

      <app-forward-button class="button-forward" [isLoading]="loaderStatus.isLoading"
              (click)="verifyAndProceed(); analyticsTracker.trackButtonClick('Lender referral','GET STARTED')">
        GET STARTED
      </app-forward-button>
    </div>
  </div>
</div>

<app-footer></app-footer>
